// export const BASEURL = `https://brij-api-v1.empirecinemas.com/`;

export const BASEURL = `https://timor-api.nuviotech.co`;

// export const ImageS3URL = `https://images.brijimages.com/`;
export const IMGBASEURL = `https://timor-api.nuviotech.co`;

export const fallbackImgSrc = `${BASEURL}assets/fallback-image.png`;
export const fallbackImgBannerSrc = `${BASEURL}assets/fallback-image-banner.png`;
export const PLATINUM = `eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6ImFiYTc1ZDBjLWM2ZjUtNDc2Mi1hZDNhLWZiNTZkZmY2ODhlZSIsImlhdCI6MTc3ODQ4MzQyOX0.vENzPsGtTn4yVepPreRHGYlESmdzixLWx4QVNNzqNu0`
export const TOKEN = PLATINUM



// WEBPACK FOOTER //
// ./src/config/index.js